/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useCallback, useState } from 'react';
import { ReactComponent as SvgIconSalesforce } from '../../../../assets/images/salesforce-icon.svg';
import { set as setOauthState } from '../../../../services/oauth-state';
import modalStyles from './Salesforce.module.scss';

import Modal from 'components/base/Modal';
import FormControl from 'components/base/FormHelpers/FormControl';

const getCenteredModalPosition = (width, height) => {
  let w = (window.innerWidth || 0) > (window.outerWidth || 0) ? window.innerWidth || 0 : window.outerWidth || 0,
    h = (window.innerHeight || 0) > (window.outerHeight || 0) ? window.innerHeight || 0 : window.outerHeight || 0,
    x = window.screenX || 0,
    y = window.screenY || 0;
  let top = y + (h - height) / 2,
    left = x + (w - width) / 2;
  return `width=${width},height=${height},top=${top},left=${left}`;
};

export default (props) => {
  const {
    name,
    isOpen,
    close,
    siteId,
    icon,
    type,
    integrationSlug,
    authenticator: { id: authenticatorId, authorization_url, authorization_success_message },
  } = props;

  const connectSalesforce = useCallback(() => {
    const modalPosition = getCenteredModalPosition(1020, 520);
    const stateString = setOauthState(type, {
      siteId,
      icon,
      authorization_success_message,
      authenticatorId,
      run_sync_job: false,
      name,
      integrationSlug,
    });
    const url = `${authorization_url}&state=${stateString}`;

    window.open(url, `${type}_oauth`, `location=no,${modalPosition}`);
  }, [siteId]);
  return (
    <Modal isOpen={isOpen} close={() => close()}>
      <div className={modalStyles.modal}>
        <h3>Connect to Salesforce</h3>
        <div className={modalStyles.contentContainer}>
          <div className={modalStyles.inputContainer}>
            <div>
              <p>Push data from Elastic Path Studio forms into Salesforce and optionally sync contacts.</p>
            </div>
            <SvgIconSalesforce width={99} height={99} />
          </div>
          <div>
            <button onClick={() => close()} className="button button-secondary">
              Cancel
            </button>
            <button
              onClick={() => {
                connectSalesforce();
              }}
              className="button button-primary"
            >
              Connect to Salesforce
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
